module.exports = __webpack_public_path__ + "static/forecast/weather/nightsnowshowers-34eaf9e4f759db280783e30bb711108c.svg";